import React from 'react';
import LogIn from '../components/login'
import '../assets/login.css'
 const LogInPage =() =>{
 return(
     <LogIn/>
 )
}
export default LogInPage;